import { STATUS_OPTIONS, type StatusId } from "#shared/constants.ts";
import { cn } from "@web/lib/utils.ts";

const STATUS_CLASS: Record<StatusId, string> = {
  none: "bg-faint/20 text-faint",
  pending: "bg-status-pending/20 text-status-pending",
  working: "bg-status-working/20 text-status-working",
  video_edit: "bg-status-video-edit/20 text-status-video-edit",
  published: "bg-accent/20 text-accent",
  paused: "bg-muted/20 text-muted",
  cancelled: "bg-status-cancelled/20 text-status-cancelled",
};

const LABEL = Object.fromEntries(STATUS_OPTIONS.map((s) => [s.id, s.label])) as Record<
  StatusId,
  string
>;

export function StatusChip({
  status,
  className,
}: {
  status: StatusId | null | undefined;
  className?: string;
}) {
  const id: StatusId = status ?? "none";
  return (
    <span
      className={cn(
        "inline-flex max-w-full truncate rounded-full px-2 py-0.5 text-xs font-medium",
        STATUS_CLASS[id],
        className,
      )}
    >
      {LABEL[id]}
    </span>
  );
}
